import { createReducer, on } from "@ngrx/store";
import { updateState } from "@obg/ngx.global";

import { RealTimeNotificationsAction } from "./real-time-notifications.action";
import { ConnectionStatus, RealTimeNotificationsState } from "./real-time-notifications.model";

const INITIAL_STATE: RealTimeNotificationsState = {
	status: ConnectionStatus.Closed,
	topics: [],
};

export const realTimeNotificationsReducer = createReducer(
	INITIAL_STATE,
	on(RealTimeNotificationsAction.disconnect, (state) => updateState(state, { status: ConnectionStatus.Closed })),
	on(RealTimeNotificationsAction.updateStatus, (state, { status }) => updateState(state, { status })),
	on(RealTimeNotificationsAction.connectionSuccess, (state) =>
		updateState(state, { status: ConnectionStatus.Connected })
	),
	on(RealTimeNotificationsAction.connectionFailure, (state) =>
		updateState(state, { status: ConnectionStatus.Closed })
	),
	on(RealTimeNotificationsAction.subscribeToChannel, (state, { channel }) =>
		updateState(state, {
			topics: [...state.topics, channel],
		})
	)
);
